import React, { Component } from 'react'
import GoogleMap from 'google-map-react'
import MyMark from './mark'

export default class Map extends Component {
  static defaultProps = {
    center: {
      lat: -34.4921,
      lng: -58.5571
    },
    zoom: 11
  };
  constructor (props) {
    super(props)


    this.state = {
      lat: -34.4921,
      lng: -58.557,
    }
    this.reCenter = this.reCenter.bind(this)
  }

  componentDidMount() {
    const { datos } = this.props
    if (datos && datos.length) {
      this.setCenterFromData(datos)
    }
  }

  reCenter(key, childProps) {
    this.setState({lat: childProps.lat});
    this.setState({lng: childProps.lng});
  }

  setCenterFromData(data) {
    const center = data
      .map(item => ({ lat: Number(item.lat), lng: Number(item.lng) }))
      .find(({ lat, lng }) => lat && !isNaN(lat) && lng && !isNaN(lng))

    center && this.setState(center)
  }

  render () {

    let data  = this.props.datos;
    let type = this.props.type
    let categories = this.props.categories

    const API_KEY = 'AIzaSyCm1MEYAHjkfpE-ygYkVPp5-0YIYuD8rxs';

    return (
      <div style={{ height: '100vh', width: '100%' }}>
        <GoogleMap
          onChildClick={(key, child) => this.reCenter(key, child)}
          yesIWantToUseGoogleMapApiInternals
          bootstrapURLKeys={{
            key: API_KEY,
            libraries: 'places',
          }}
          defaultCenter={this.props.center}
          center={this.state}
          defaultZoom={this.props.zoom}
        >
          {
            data.map((item, index) =>
              ((item.lat !== '0.0') && (item.lng !== '0.0')) ? (
                <MyMark
                  lat={parseFloat(item.lat)}
                  lng={parseFloat(item.lng)}
                  key={index}
                  item={item}
                  type={type}
                  categories={categories}
                />
              ) : ''
            )
          }
        </GoogleMap>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Maps/index.js